export class ControlledPromise<T> {
  public readonly promise: Promise<T>;

  public readonly resolve: (value: T | PromiseLike<T>) => void;

  public readonly reject: (reason?: any) => void;

  private _ended = false;

  get ended() {
    return this._ended;
  }

  constructor() {
    let res!: (value: T | PromiseLike<T>) => void;
    let rej!: (reason?: any) => void;

    this.promise = new Promise<T>((resolve, reject) => {
      res = (value) => {
        this._ended = true;
        resolve(value);
      };
      rej = (err) => {
        this._ended = true;
        reject(err);
      };
    });

    this.resolve = res;
    this.reject = rej;
  }
}
